/**
 * reader-style-preset (= 副次 spec) の type 定義。
 *
 * core-domain dep なし doctrine: client-player local type で完結。
 * server 影響ゼロ (= 本 spec client-only)。
 *
 * 設計詳細は `.kiro/specs/reader-style-preset/design.md` を参照。
 */

export type ReaderFontSize = "small" | "medium" | "large";
export type ReaderTheme = "light" | "dark";
export type ReaderPacing = "slow" | "normal" | "fast";

/**
 * moderation-fallback-ux (Phase 5+ Tier 5A 第 3 段) Phase 6:
 * flagged content (= moderationStatus='flagged') の表示制御。
 * default 'hide' (= flagged content 完全 hide で reader continuity 維持)。
 * 'show' で reader 自己責任で表示 (= 18+ 確認は UI 層で hop)。 'hidden' / 'appealing' は本 toggle で影響しない (= 強制非表示)。
 */
export type FlaggedContentVisibility = "hide" | "show";

export interface ReaderStylePreset {
  fontSize: ReaderFontSize;
  theme: ReaderTheme;
  pacing: ReaderPacing;
  flaggedContentVisibility: FlaggedContentVisibility;
  // scene-beat-preview-toggle (= narrative-quality-future-enhancements 推奨順位 1) Phase 1:
  // reader 通常表示で beat 構造 (= CurrentBeatIndicator) を opt-in 表示するかの toggle。
  // default false (= 既存 reader UX 不変、 debug overlay 経路のみ active)。
  // true で SceneView に conditional mount される (= Phase 3 配線、 placement-agnostic UI 継承)。
  showBeatStructure: boolean;
}

export const DEFAULT_PRESET: ReaderStylePreset = {
  fontSize: "medium",
  theme: "light",
  pacing: "normal",
  flaggedContentVisibility: "hide",
  showBeatStructure: false,
};

// pacing → 1 字あたり ms multiplier (= calcAutoAdvanceMs base 50ms に乗算)。
// slow = ×1.5, normal = ×1.0, fast = ×0.5 (= spec δ-1 採択)。
export const PACING_MULTIPLIER: Record<ReaderPacing, number> = {
  slow: 1.5,
  normal: 1.0,
  fast: 0.5,
};

export const FONT_SIZE_TO_PX: Record<ReaderFontSize, number> = {
  small: 14,
  medium: 16,
  large: 18,
};

export const STORAGE_KEY = "palimia-reader-style-preset";
